'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormatedObservation = exports.getObservationFormater = exports.makeObservationFormater = exports.getObservationFormaterValues = exports.getObservationFormaterValue = exports.getObservationsFormaterAttributes = exports._getObservationsFormaterAttributes = exports.parseAttributeFormaterIds = exports.getFormaterAttribute = exports.DEFAULT_DECIMALS_ATTR_IDS = exports.DEFAULT_PREFSCALE_ATTR_IDS = undefined;
var _isNan = require('babel-runtime/core-js/number/is-nan');
var _isNan2 = _interopRequireDefault(_isNan);
var _memoizee = require('memoizee');
var _memoizee2 = _interopRequireDefault(_memoizee);
var _numeral = require('numeral');
var _numeral2 = _interopRequireDefault(_numeral);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _ = require('./');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var DEFAULT_PREFSCALE_ATTR_IDS = exports.DEFAULT_PREFSCALE_ATTR_IDS = ["PREF_SCALE"];
var DEFAULT_DECIMALS_ATTR_IDS = exports.DEFAULT_DECIMALS_ATTR_IDS = ["DECIMALS"];
var getFormaterAttribute = exports.getFormaterAttribute = function getFormaterAttribute(ids, attributes) {
  return R.find(function (attr) {
    return R.includes(attr.id, ids);
  }, attributes);
};
var parseAttributeFormaterIds = exports.parseAttributeFormaterIds = function parseAttributeFormaterIds() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prefscale = R.prop('prefscale', ids);
  var decimals = R.prop('decimals', ids);
  decimals = R.isNil(decimals) ? DEFAULT_DECIMALS_ATTR_IDS : decimals;
  prefscale = R.isNil(prefscale) ? DEFAULT_PREFSCALE_ATTR_IDS : prefscale;
  return {
    decimals: R.is(Array, decimals) ? decimals : [decimals],
    prefscale: R.is(Array, prefscale) ? prefscale : [prefscale]
  };
};
var _getObservationsFormaterAttributes = exports._getObservationsFormaterAttributes = function _getObservationsFormaterAttributes(data, ids) {
  return R.pipe(_.extractSdmxArtefacts, function (_ref) {
    var attributes = _ref.attributes;
    var _parseAttributeFormat = parseAttributeFormaterIds(ids),
      decimals = _parseAttributeFormat.decimals,
      prefscale = _parseAttributeFormat.prefscale;
    return {
      decimals: getFormaterAttribute(decimals, attributes),
      prefscale: getFormaterAttribute(prefscale, attributes)
    };
  })(data);
};
var getObservationsFormaterAttributes = exports.getObservationsFormaterAttributes = (0, _memoizee2.default)(_getObservationsFormaterAttributes);
var getObservationFormaterValue = exports.getObservationFormaterValue = function getObservationFormaterValue(observation, attribute) {
  var attributeIndex = R.prop('index', attribute);
  var attributeValueIndex = R.nth(attributeIndex, observation);
  return R.nth(attributeValueIndex, R.propOr([], 'values', attribute));
};
var getObservationFormaterValues = exports.getObservationFormaterValues = function getObservationFormaterValues(formaterAttributes) {
  return function (observation) {
    return {
      decimals: getObservationFormaterValue(observation, R.prop('decimals', formaterAttributes)),
      prefscale: getObservationFormaterValue(observation, R.prop('prefscale', formaterAttributes))
    };
  };
};
var makeObservationFormater = exports.makeObservationFormater = function makeObservationFormater(formaterValues) {
  var prefscale = 0;
  if (!R.isNil(R.prop('prefscale', formaterValues))) {
    prefscale = Number(R.propOr('0', 'id', formaterValues.prefscale));
  }
  var decimals = null;
  if (!R.isNil(R.prop('decimals', formaterValues))) {
    var _decimals = Number(R.prop('id', formaterValues.decimals));
    decimals = R.is(Number, _decimals) && !(0, _isNan2.default)(_decimals) ? _decimals : null;
  }
  var format = '0,0';
  if (R.isNil(decimals)) {
    format = R.concat(format, '.[0000000]');
  } else if (decimals > 0) {
    format = R.concat(format, '.[' + '0'.repeat(decimals) + ']');
  }
  return function (value) {
    return (0, _numeral2.default)(Number(value)).multiply(Math.pow(10, R.negate(prefscale))).format(format);
  };
};
var getObservationFormater = exports.getObservationFormater = function getObservationFormater(observation, formaterAttributes) {
  return R.pipe(R.tail, getObservationFormaterValues(formaterAttributes), makeObservationFormater)(observation);
};
var getFormatedObservation = exports.getFormatedObservation = function getFormatedObservation(observation, formaterAttributes) {
  var formater = getObservationFormater(observation, formaterAttributes);
  return formater(R.head(observation));
};